import { createContext, useContext } from "react";

const InsightsPreviewOptOutContext = createContext<(() => void) | undefined>(
  undefined
);

export const InsightsPreviewOptOutProvider =
  InsightsPreviewOptOutContext.Provider;

export function useInsightsPreviewOptOut() {
  return useContext(InsightsPreviewOptOutContext);
}
